import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { ToastComponent } from "../../../../shared/components/toast/toast.component";
import { AdminNavigationComponent, AdminSectionId } from "../../components/admin-navigation/admin-navigation.component";
import { AdminTopbarComponent } from "../../components/admin-topbar/admin-topbar.component";
import { TranslocoPipe } from '@jsverse/transloco';
import { AdminGasTaxesFilesComponent } from "../../components/admin-gas-taxes-files/admin-gas-taxes-files.component";
import { AdminGasDistributionTariffFilesComponent } from "../../components/admin-gas-distribution-tariff-files/admin-gas-distribution-tariff-files.component";
import { DropDownSectionComponent } from "../../../../shared/components/drop-down-section/drop-down-section.component";
import { AdminAcciseGasFilesComponent } from "../../components/admin-accise-gas-files/admin-accise-gas-files.component";
import { AdminElectricityAndGasPricesComponent } from "../../components/admin-electricity-and-gas-prices/admin-electricity-and-gas-prices.component";

@Component({
  selector: 'app-admin-file-management-page',
  standalone: true,
  imports: [ToastComponent, AdminNavigationComponent, AdminTopbarComponent, TranslocoPipe, AdminGasTaxesFilesComponent, AdminGasDistributionTariffFilesComponent, DropDownSectionComponent, AdminAcciseGasFilesComponent, AdminElectricityAndGasPricesComponent],
  templateUrl: './admin-file-management-page.component.html',
  styleUrl: './admin-file-management-page.component.css'
})
export class AdminFileManagementPageComponent implements OnInit {
  constructor(private cd: ChangeDetectorRef) { }

  // Section Enum
  AdminSectionId = AdminSectionId;

  // Toast
  @ViewChild(ToastComponent, { static: true }) toast!: ToastComponent;

  ngOnInit(): void {
    this.cd.detectChanges();
  }
}
